import { render, staticRenderFns } from "./CURPVerification.vue?vue&type=template&id=c303cf78&lang=html&"
import script from "./CURPVerification.vue?vue&type=script&lang=js&"
export * from "./CURPVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports